import React from 'react'

function DietCaresec3() {

const EngagementData = [
        {
            Head: "CRM for Nutritionists and Dieticians",
            Desc: "Our CRM allows you to keep a track of customer profiles and data, while managing appointments, enquiries and complaints all in one place in a systematic and concise manner. You can be sure to never fumble up your appointment records again!"
        },
        {
            Head: "Meal Planning Software and Menu Builder",
            Desc: "Diet Care gives you a fully customizable meal builder and menu card! Manage packages & boxes in the admin portal, Build customized menus, Automatically generate nutritional analysis, Include recipes with instructions into meal plans, Choose required energy and macronutrients, Keep a track of Box Counts and Box History"
        },
        {
            Head: "Calendar, Appointments, and Reminders",
            Desc: "Experience effortless convenience with just a few clicks! Follow a calendar to manage schedules and deadlines, Effortlessly arrange first visit and follow-up appointments, Send your available meeting dates to clients with one click, Monitor customer appointments and cancellations, Set automatic reminders to increase client compliance"
        },
        {
            Head: "Automated reports and templates",
            Desc: "The software boasts precise automated reports that can visually help you keep a track of the very minute details to their very best."
        },
        {
            Head: "Graphical Representation of Consolidated Data",
            Desc: "Graphical representation of data allows for the clear portrayal of key information. Graphs and charts are effective visual tools because they present information quickly and easily, thus allowing you to have a better understanding of the details you are dealing with."
        },
        {
            Head: "CLIENT PAYMENTS AND REPORTS",
            Desc: "Diet Care provides you with the right tools to track every single report that comes your way, be it client details or delivery counts."
        },
        {
            Head: "TECHNICAL SUPPORT",
            Desc: "Our team is dedicated to providing you the support that you need. For both, the Web App as well as the Mobile App, you can be sure to find no glitches. However, in the event of a mishap, Diet Care takes on the guarantee to resolve your technical query as soon as possible."
        }
    ]

  return (
    <section className='engage-sec' style={{marginBottom: "0", borderBottom: "1px solid #fff"}}>
        <div className='container'>
            <h3>All Features</h3>
            <ul>
                {
                  EngagementData.map((Engagement, index)=>(
                    <li key={index} style={{marginBottom: "20px"}}>
                        <h4>{Engagement.Head}</h4>
                        <p>{Engagement.Desc}</p>
                    </li>   
                  ))  
                }
            </ul>
        </div>
    </section>
  )
}

export default DietCaresec3
